import {
  modalEmailMessagesPaginationState,
  modalEmailMessagesSearchState
} from 'Hooks/useModalEmailMessages/useModalEmailMessages'
import { Group, Item, SearchForm } from 'mailup-web-components'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import { useResetRecoilState, useSetRecoilState } from 'recoil'
import { InputSearchString } from './InputSearchString'

const Search = () => {
  const intl = useIntl()
  const setSerachString = useSetRecoilState(modalEmailMessagesSearchState)
  const resetEmailPagination = useResetRecoilState(
    modalEmailMessagesPaginationState
  )
  const resetEmailSearch = useResetRecoilState(modalEmailMessagesSearchState)

  const [searchText, setSearchParams] = useState('')

  const handleInputChange = (e) => {
    const val = e.target.value
    setSearchParams(val)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const handleSubmit = (e) => {
    setSerachString((prev) => ({
      ...prev,
      searchString: searchText
    }))
  }

  const handleReset = (e) => {
    resetEmailPagination()
    resetEmailSearch()

    setSearchParams('')
  }

  return (
    <SearchForm
      advanced={false}
      labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
      labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
      onClickToggle={() => {}}
      onClickReset={handleReset}
      onSubmit={handleSubmit}
      expanded={false}
    >
      <Group>
        <Item>
          <InputSearchString
            handleKeyPress={handleKeyPress}
            handleInputChange={handleInputChange}
            searchText={searchText}
          />
        </Item>
      </Group>
    </SearchForm>
  )
}

export default Search
